module.exports = __webpack_public_path__ + "static/img/emotes-small.741fb52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/twitch/emotes-small.png
// module id = mike
// module chunks = 35